import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BusinessInfoInterface } from '../../models/dashboard/settings/business-info';

interface IInitialState {
  businessInfo?: BusinessInfoInterface;
}

const initialState: IInitialState = {
  businessInfo: undefined
};

const businessInfoDataSlice = createSlice({
  name: 'businessInfoSlice',
  initialState,
  reducers: {
    setBusinessInfo(state, action: PayloadAction<BusinessInfoInterface>) {
      state.businessInfo = action.payload;
    },
  },
});

export const businessInfoDataActions = businessInfoDataSlice.actions;
export default businessInfoDataSlice.reducer;
